import {bindLoading} from './index';
import {BookingService, ManageService} from '../services';
import {isDev} from '../constants';

export default {
    namespaced: true,
    state: {
        forms:[],
        drewResults: {},
        noDrewForms: [],
        statistic:{},
        seed: 0,
        drewStatistic: {}
    },

    mutations: {
        saveForms(current, forms) {
            current.forms.splice(0);
            current.forms = forms;
        },
        saveNoDrewForms(current, forms) {
            current.noDrewForms.splice(0);
            current.noDrewForms = forms;
        },
        saveSeed(current, seed){
            current.seed = seed;
        },
        saveDrewResults(current, {results, statistic}){
            current.drewResults = undefined;
            current.drewResults = {...results};
            current.statistic = undefined;
            current.statistic = {...statistic};
        },

        saveDrewStatistic(current, statistic){
            current.drewStatistic = undefined;
            current.drewStatistic = statistic;
        }
    },
    actions: {
        async submitSuperFormAction({dispatch, commit}, formData) {
            return await bindLoading(commit, async () => {
                return await BookingService.submitSuperForm(formData);
            }, 'manage')
        },
        async getFormsAction({dispatch, commit}) {
            await bindLoading(commit, async () => commit('saveForms', await ManageService.getForms()), 'manage')
        },
        async getDrewStatisticAction({dispatch, commit}, month) {
            await bindLoading(commit, async () => commit('saveDrewStatistic'
                , await ManageService.getDrewStatistic(month)), 'manage')
        },
        async getNoDrewFormsAction({dispatch, commit}, month) {
            await bindLoading(commit, async () => commit('saveNoDrewForms', await ManageService.getNoDrewForms(month)), 'manage')
        },
        async deleteFormAction({dispatch, commit, state}, id) {
            return await bindLoading(commit, async () => {

                const result = await ManageService.deleteForm(id);

                if (result.success) {
                    const forms = [...state.forms.filter(r => r.id !== id)];
                    commit('saveForms', forms);
                }
                return result;
            }, 'manage');

        },

        async tryDrawAction({dispatch, commit, state}, {roomId, month, multiple, seed}) {
            await bindLoading(commit, async () => {
                const r = Math.floor(Date.now().valueOf() / (isDev ? 1000 : 15000));
                commit('saveSeed', r);
                const drawResults = await ManageService.tryDraw({roomId, month, r, multiple});
                commit('saveDrewResults',  drawResults);
            }, 'manage');
        },

        async commitDrawAction({dispatch, commit, state}, {roomId, month, multiple}) {
            return await bindLoading(commit, async () => {
                return await ManageService.commitDraw({roomId, month, r:state.seed, multiple});
            }, 'manage');
        },

        async sendNoDrewMailAction({dispatch, commit, state}, mail) {
            return await bindLoading(commit, async () => {
                const {success} = await ManageService.sendNoDrewMail(mail);
                if(success){
                    const newForms = [...state.noDrewForms.filter(f => f.id !== mail.id),
                        {...state.noDrewForms.find(f => f.id === mail.id), isNoDrewMailSend : true}
                    ];
                    commit('saveNoDrewForms', newForms);
                }
                return success;
            }, 'manage');
        },

        async addDrewManuallyAction({dispatch, commit, state}, picks){
            return await bindLoading(commit, async () => {
                const {success} = await ManageService.addDrewManually(picks);
                if(success){
                    const newForms =state.noDrewForms.filter(f => f.id !== picks[0].formId);
                    commit('saveNoDrewForms', newForms);
                }
                return success;
            }, 'manage');
        }
    }
}